import React from "react";
import { InfoWindow } from "@react-google-maps/api";
import { normalizeWebsite, isValidPhone } from "../../utils/geo";

const INFO_WINDOW_Y_OFFSET = -42;

function MapInfoWindow({ result, onClose }) {
  if (!result || !result.latLng) return null;

  const rawPhone = result.program_site_phones?.phone_1
    || result.program_site_phones?.phone_2
    || result.program_phones?.phone_1
    || result.site_phones?.phone_1
    || result.agency_phones?.phone_1
    || result.phone;
  const phone = isValidPhone(rawPhone) ? rawPhone : null;
  const website = normalizeWebsite(result.program_site_website || result.program_website || result.site_website || result.agency_website || result.website || "");

  return (
    <InfoWindow
      position={result.latLng}
      onCloseClick={onClose}
      options={{ pixelOffset: new google.maps.Size(0, INFO_WINDOW_Y_OFFSET) }}
    >
      <div className="map-info">
        <h4 className="name resource-name">{result.name || result.program_name || result.agency_name}</h4>
        {result.addressLine && <div className="sub-head address resource-address">{result.addressLine}</div>}
        {(phone || website || result.latLng) && (
          <div className="resource-information">
            {phone && (
              <a className="information-item small-label phone" href={`tel:${phone.replace(/\D/g, "")}`}>
                <i className="ico ico-mobile">&nbsp;</i>
                <span className="information">{phone}</span>
              </a>
            )}
            {website && (
              <a className="information-item small-label website" href={website} target="_blank" rel="noopener noreferrer">
                <i className="ico ico-computer">&nbsp;</i>
                <span className="information">View Website</span>
              </a>
            )}
            {result.latLng && (
              <a
                className="information-item small-label directions"
                href={`https://www.google.com/maps/dir/?api=1&destination=${result.latLng.lat},${result.latLng.lng}`}
                target="_blank"
                rel="noopener noreferrer"
              >
                <i className="ico ico-marker">&nbsp;</i>
                <span className="information">Get Directions</span>
              </a>
            )}
          </div>
        )}
      </div>
    </InfoWindow>
  );
}

export default MapInfoWindow;
